export default __webpack_public_path__ + "static/subset-UniNeueBook-Italic-9804c8c8dbeedc086122ff884e7e4575.woff2";